const moduleNameKey = "organizationsTableAdminPanel";

export const organizationsTableAdminPanelEn = {
  [moduleNameKey]: {
    typeHeader: "Type",
    nameHeader: "Name",
    noOrganizations: "No organizations found.",
    otherOrganizationType: "Other",
  },
};

export const organizationsTableAdminPanelPtBr = {
  [moduleNameKey]: {
    typeHeader: "Tipo",
    nameHeader: "Nome",
    noOrganizations: "Nenhuma organização encontrada.",
    otherOrganizationType: "Outro",
  },
};

export const organizationsTableAdminPanelDe = {
  [moduleNameKey]: {
    typeHeader: "Typ",
    nameHeader: "Name",
    noOrganizations: "Keine Organisationen gefunden.",
    otherOrganizationType: "Sonstige",
  },
};

export const organizationsTableAdminPanelZhHans = {
  [moduleNameKey]: {
    typeHeader: "类型",
    nameHeader: "名称",
    noOrganizations: "未找到组织。",
    otherOrganizationType: "其他",
  },
};

export const organizationsTableAdminPanelIt = {
  [moduleNameKey]: {
    typeHeader: "Tipo",
    nameHeader: "Nome",
    noOrganizations: "Nessuna organizzazione trovata.",
    otherOrganizationType: "Altro",
  },
};

export const organizationsTableAdminPanelEs = {
  [moduleNameKey]: {
    typeHeader: "Tipo",
    nameHeader: "Nombre",
    noOrganizations: "No se encontraron organizaciones.",
    otherOrganizationType: "Otro",
  },
};

export const organizationsTableAdminPanelNl = {
  [moduleNameKey]: {
    typeHeader: "Type",
    nameHeader: "Naam",
    noOrganizations: "Geen organisaties gevonden.",
    otherOrganizationType: "Overig",
  },
};

export const organizationsTableAdminPanelTr = {
  [moduleNameKey]: {
    typeHeader: "Tür",
    nameHeader: "Ad",
    noOrganizations: "Organizasyon bulunamadı.",
    otherOrganizationType: "Diğer",
  },
};
